import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import {Field, change} from "redux-form";
import Grid from "@material-ui/core/Grid";
import RadioField from "../RadioField";

import styles from "./question.module.scss";

function FirstQuestion(props) {
  const handleChange = (_, newValue, __, name) => {
    props.change(`quiz`, name, newValue);
    if (newValue === `male`) {
      props.change(`quiz`, `whom`, `boyfriend`);
    } else {
      props.change(`quiz`, `whom`, `girlfriend`);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <h3 className={styles.title}>Укажите пол</h3>
      </Grid>
      <Grid item xs={12}>
        <div className={classNames(styles.icon, styles.genderIcon)}></div>
      </Grid>
      <Grid container className={styles.content}>
        <Grid item xs={6}>
          <Field
            name="gender"
            component={RadioField}
            type="radio"
            value="male"
            label="Мужской"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="gender"
            component={RadioField}
            type="radio"
            value="female"
            label="Женский"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

FirstQuestion.propTypes = {
  change: PropTypes.func
};

export default connect(null, {
  change
})(FirstQuestion);
